import type { RumInitConfiguration } from '@datadog/browser-rum';

// Known-noise RUM errors, folded from the `fix/rum-*` branches (DEV-27946).
// `exact` matches the whole message; `includes` matches a substring.
const DROPPED_ERROR_MESSAGES: ReadonlyArray<{ exact: string } | { includes: string }> = [
  { exact: 'Script error.' },
  { exact: 'Uncaught "Script error."' },
  { includes: 'network connection was lost' },
  { includes: 'connection appears to be offline' },
  { includes: 'Unable to resolve host' },
  { includes: 'specified hostname could not be found' },
  { includes: 'Load failed' },
  { includes: 'Failed to fetch' },
  { includes: 'Software caused connection abort' },
  { includes: 'Error sending segment performance metrics' },
  { includes: 'Failed to connect to api.segment.io' },
];

export const rumBeforeSend: NonNullable<RumInitConfiguration['beforeSend']> = event => {
  if (event.type !== 'error') return true;
  const message = event.error?.message ?? '';
  return !DROPPED_ERROR_MESSAGES.some(rule =>
    'exact' in rule ? message === rule.exact : message.includes(rule.includes)
  );
};
